import { type ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { AlertDialogHeader as AlertDialogHeaderBase } from "./base/AlertDialogBase"

export type AlertDialogHeaderProps = ComponentProps<
  typeof AlertDialogHeaderBase
>

function AlertDialogHeader(props: AlertDialogHeaderProps) {
  const { className, ...alertDialogHeaderBaseProps } = props

  return (
    <AlertDialogHeaderBase
      className={cn("ui-alert-dialog-header", className)}
      {...alertDialogHeaderBaseProps}
    />
  )
}

export default AlertDialogHeader
